import styled from 'styled-components';

const Content = styled.div`
  h2 {
    font-size: 1.2rem;
    margin: 20px -1px 15px;

    :first-child {
      margin: -5px -1px 15px;
    }
  }

  p.subtitle { margin-bottom: 20px }
`;

export default Content;
